import { Expose, Transform } from 'class-transformer';
import { IsInt, IsOptional } from 'class-validator';

export default class MarketsDocumentItemModel {
    @Expose()
    @IsInt()
    position!: number;

    @Expose()
    @IsInt()
    oldPosition!: number;

    @Expose()
    @IsOptional()
    @IsInt()
    page?: number;

    @Expose()
    @IsOptional()
    @IsInt()
    @Transform((_, plain) => {
        if (!plain.number_of_hotels) {
            return undefined;
        }
        return Number(plain.number_of_hotels);
    })
    numberOfHotels?: number;

    @Expose()
    @IsOptional()
    @IsInt()
    link?: string;

    @Expose()
    @Transform((_, plain) => plain.promoted)
    promoted?: boolean;

    @Expose()
    @Transform((_, plain) => (
        plain.update_date
            ? new Date(plain.update_date)
            : null
    ))
    updateDate?: Date;
}
